import { render, staticRenderFns } from "./AutorizarTraspasosView.vue?vue&type=template&id=dd88fbd6&"
import script from "./AutorizarTraspasosView.vue?vue&type=script&lang=js&"
export * from "./AutorizarTraspasosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports